import MobileFooter from './MobileFooter'
export default MobileFooter
